export const FEATURELIST_SORT_OPTIONS = [
    'alphabetical',
    'original',
];
export const ALT_COLNAME = 'Alternate ID';
//# sourceMappingURL=constants.js.map